import { memo, useEffect, useMemo, useRef } from 'react'
import styles from './index.module.less'
import {
  MainLogo,
  MenuDownload,
  MenuSetting,
  MenuSideTodo,
  MenuWorkOrder,
  MenuWorkshop,
  NaviIcon,
  SvgBizConfigIcon,
  SvgUserSmall,
} from '@/components/icons'
import { AppstoreAddOutlined } from '@ant-design/icons'
import classNames from 'classnames'
import { useSetState } from 'ahooks'
import { Scrollbars } from 'react-custom-scrollbars'
import MenuItem from '@/layouts/MenuSide/MenuItem'
import AppAvatar from '@/assets/user.svg?react'
import { Avatar, Skeleton, Divider, notification } from 'antd'
import useGlobalStore from '@/store'
import MenuCollapseBtn from '@/layouts/MenuSide/MenuCollapseBtn'
import { baseConfig } from '@/config/base-config'
import { useNavigate } from 'react-router-dom'
import useWorkshopStore from '@/store/workshop'
import { useShallow } from 'zustand/react/shallow'
import useWorkOrderStore from '@/store/workOrder'
import UserInfoPanelPopover from '@/layouts/header/components/userInfoPanelPopover'
import { changePosition } from '@/services'
import useUser from '@/hooks/useUser'
import useMenuCovert from '@/hooks/useMenuCovert.tsx'
import useNavigateMicro from '@/hooks/useNavigateMicro.ts'
import useMenuSelection from '@/hooks/useMenuSelection.ts'
import AppPopover from '@/layouts/MenuSide/AppPopover.tsx'
// import { getUnReadCount } from '@/services/pns.ts'
import useUnReadCount from '@/hooks/useUnReadCount.ts'
import { triggerEvent } from '@/utils/customEvent.ts'
import useAuthMenu from '@/hooks/useAuthMenu.ts'
import { getUser } from '@/common/utils.ts'
import menuSideBg from '@/assets/menu-bg.png'

const MenuSide = memo((props: any) => {
  const { onTabChange, logout } = props

  const scrollRef = useRef<any>()
  const timeRef = useRef<any>(null)
  const {
    globalUser,
    globalMenu,
    menuActive,
    menuLoading,
    setMenuActive,
    setMenuCollapsedStart,
    setMenuCollapsedEnd,
    menuCollapsed,
    setMenuCollapsed,
    selectedMenu,
    hasAuthMenu,
    userExtend,
    identities,
    getCurrentIdentity,
  } = useGlobalStore(
    useShallow((state: any) => ({
      globalUser: state.user,
      globalMenu: state.menu,
      menuLoading: state.menuLoading,
      menuActive: state.menuActive,
      selectedMenu: state.selectedMenu,
      setMenuActive: state.setMenuActive,
      menuCollapsed: state.menuCollapsed,
      setMenuCollapsed: state.setMenuCollapsed,
      setMenuCollapsedStart: state.setMenuCollapsedStart,
      setMenuCollapsedEnd: state.setMenuCollapsedEnd,
      hasAuthMenu: state.hasAuthMenu,
      userExtend: state.userExtend,
      identities: state.identities,
      getCurrentIdentity: state.getCurrentIdentity
    }))
  )

  const { appNav, allApp, navLoading } = useWorkshopStore(
    useShallow((state: any) => ({
      appNav: state.appNav,
      allApp: state.allApp,
      navLoading: state.navLoading,
    }))
  )

  const { storeData } = useWorkOrderStore(
    useShallow((state: any) => ({
      storeData: state.data,
    }))
  )

  const [state, setState]: any = useSetState({
    menu: [],
    menuOverflow: false,
    hasConfigMenu: false,
  })

  const [countState] = useUnReadCount(['messageCount', 'downloadCount'])

  const [selectedMenuKey, selectedGlobalMenuItem] = useMenuSelection()

  useEffect(() => {
    if (selectedMenuKey) {
      setMenuActive(selectedMenuKey)
    }
    if (selectedGlobalMenuItem) {
      onTabChange(selectedGlobalMenuItem)
    }
  }, [selectedMenuKey, selectedGlobalMenuItem])

  const { convertMenu } = useMenuCovert()

  const authMenu = useAuthMenu(allApp)
  // const authMenu = useAuthMenu(appNav)

  useEffect(() => {
    console.log(authMenu)
    if (Array.isArray(authMenu) && authMenu.length) {
      // 权限过滤
      setState({
        menu: convertMenu(authMenu),
      })
    }
  }, [authMenu])

  useEffect(() => {
    setMenuOverflow()
    window.addEventListener('resize', setMenuOverflow)
    return () => {
      window.removeEventListener('resize', setMenuOverflow)
    }
  }, [state.menu])

  useEffect(() => {

  }, [identities])

  const _avatar = globalUser?.photo

  const navigate = useNavigate()

  const { saveUserToken } = useUser()

  const [navigateMicroPage, navigateMain] = useNavigateMicro()

  useEffect(() => {
    if (globalMenu.length) {
      const hasConfigMenu = globalMenu.find(d => d.key === 'BusinessPlus')
      setState({
        hasConfigMenu,
      })
    }
  }, [globalMenu])

  const setMenuOverflow = () => {
    if (state.menu.length) {
      const scrollHeight = scrollRef.current.getScrollHeight()
      const clientHeight = scrollRef.current.getClientHeight()
      const scrollTop = scrollRef.current.getScrollTop()
      setState({
        menuOverflow: scrollHeight - scrollTop > clientHeight,
      })
    }
  }

  const routeToPage = (code, menuKey) => {
    const menuItem = globalMenu.find(item => item.code === code)
    const appData = allApp.find(item => item.code === code)
    // console.log(code, menuKey, menuItem)
    onTabChange(menuItem) // updateSelectedApp
    // console.log('menuKey', menuKey)
    setMenuActive(menuKey)
    // console.log(navigateMain)
    if (appData.app.urlPrefix === '/') {
      navigateMain(appData, menuItem)
    } else {
      navigateMicroPage(appData, menuItem)
    }
  }

  const handleLocalMenuClick = record => {
    navigate(record.route)
    setMenuActive(record.route)
  }

  const handleMenuClick = record => {
    if (record.appCode === 'sellPlus' || record.appCode === 'SellPlus') {
      window.open('/deal/home?onlyBuy=false')
      return
    }
    routeToPage(record.appCode, record.appCode)
  }

  const handleAdminClick = () => {
    // routeToPage('CAAS', 'upms')
    routeToPage('enterpriseBackground', 'upms')
  }

  const handleBaseConfigClick = () => {
    routeToPage('BusinessPlus', 'config')
  }
  const handleServiceConfigClick = () => {
    const menuItem = globalMenu.find(item => item.code === 'Config')
    onTabChange(menuItem)
    navigate('/config/serviceConfig/nodeConfig')
    setMenuActive('serviceConfig')
  }
  const handleChangePosition = id =>
    changePosition(id).then(res => {
      saveUserToken(res)
    })

  const handleCollapse = () => {
    setMenuCollapsedStart()
    setMenuCollapsed(!menuCollapsed)
    clearInterval(timeRef.current)
    timeRef.current = setTimeout(() => {
      triggerEvent('UPDATE_MENU_SIZE')
    }, 150)
  }

  const handleCollapseChangeEnd = () => {
    setMenuCollapsedEnd()
  }

  const localMenus = useMemo(
    () => [
      { title: '工作台', icon: <MenuWorkshop />, route: '/main', iconStyle: { marginTop: -1 } },
      {
        title: '消息通知',
        icon: <MenuSideTodo />,
        route: '/main/chat',
        badge: countState.messageCount,
      },
      {
        title: '工单中心',
        icon: <MenuWorkOrder />,
        route: storeData.workOrderPath,
      },
    ],
    [storeData.workOrderPath, countState.messageCount]
  )

  const currentIdentity = getCurrentIdentity(identities)
  const hasAdmin = userExtend.admin || hasAuthMenu
  return (
    <div
      className={classNames(styles.menuSide, { [styles.collapsed]: menuCollapsed })}
      onTransitionEnd={handleCollapseChangeEnd}
    >
      <div className={styles.mainLogo}>
        <div className={styles.logoGroup}>
          <div className={styles.logoIcon}>
            <MainLogo />
          </div>
          {menuCollapsed ? null : <div className={styles.mainTitle}>积木云装</div>}
        </div>
        {menuCollapsed ? null : <div className={styles.versionCode}>SHJ V1.1.0</div>}
      </div>

      <div className={classNames(styles.menuList, styles.menuLocal)}>
        {localMenus.map(d => (
          <MenuItem
            key={d.route}
            icon={d.icon}
            active={menuActive?.split?.('/')?.[1] === 'flow' ? menuActive?.split('/')?.[1] === d.route?.split('/')?.[1] : menuActive === d.route}
            onClick={() => handleLocalMenuClick(d)}
            styles={{ icon: { marginTop: '-1px' } }}
            badge={d.badge}
            // badgeColor={d.badgeColor}
            collapsed={menuCollapsed}
            title={d.title}
          >
            {d.title}
          </MenuItem>
        ))}
      </div>

      <div
        className={classNames(styles.menuList, styles.scrollMenu, { [styles.hasAdmin]: hasAdmin })}
      >
        <Scrollbars
          autoHide
          ref={scrollRef}
          onScrollStop={setMenuOverflow}
          onScrollStart={setMenuOverflow}
        >
          {state.menu
            ?.filter(d => d.appCode !== 'enterpriseBackground' && d.appCode !== 'BusinessPlus')
            .map((d, index) => (
              <MenuItem
                key={d.nid}
                icon={d.icon}
                active={menuActive === d.appCode || menuActive === d.key}
                onClick={() => handleMenuClick(d)}
                styles={{ icon: { marginTop: '-1px', minWidth: 16 } }}
                title={d.label}
                collapsed={menuCollapsed}
                iconIndex={index}
              >
                {d.label}
              </MenuItem>
            ))}

          {(menuLoading || navLoading) && !state.menu.length ? (
            <div style={{ margin: '0 10px' }}>
              <Skeleton active />
            </div>
          ) : null}
        </Scrollbars>
      </div>

      <div
        className={classNames(styles.menuBottom, styles.menuFiexd, {
          [styles.topShadow]: state.menuOverflow,
        })}
      >
        <MenuItem
          icon={<MenuDownload />}
          active={menuActive === '/main/download'}
          onClick={() => handleLocalMenuClick({ route: '/main/download' })}
          title={'下载中心'}
          badge={countState.downloadCount}
          badgeColor="#0064FF"
          collapsed={menuCollapsed}
        >
          下载中心
        </MenuItem>

        {state.hasConfigMenu ? (
          <MenuItem
            icon={<SvgBizConfigIcon />}
            active={menuActive === 'config'}
            onClick={handleBaseConfigClick}
            title={'业务配置'}
            badgeColor="#0064FF"
            collapsed={menuCollapsed}
          >
            业务配置
          </MenuItem>
        ) : null}

        {hasAdmin ? (
          <MenuItem
            icon={<MenuSetting />}
            active={menuActive === 'upms'}
            onClick={handleAdminClick}
            title={'企业后台'}
            collapsed={menuCollapsed}
          >
            企业后台
          </MenuItem>
        ) : null}

        <div style={{ paddingLeft: 15, paddingRight: 15 }}>
          <Divider
            style={{
              marginBottom: 4,
              marginTop: 4,
              backgroundColor: 'rgba(255, 255, 255, 1)',
            }}
          />
        </div>

        <UserInfoPanelPopover
          userInfo={globalUser}
          onChangePosition={handleChangePosition}
          logout={logout}
        >
          <MenuItem
            icon={
              <Avatar
                size={24}
                style={{ padding: 0, backgroundColor: '#fff' }}
                src={_avatar}
                alt="头像"
                icon={<SvgUserSmall style={{ fontSize: 24, flexShrink: 0 }} />}
              />
            }
            styles={{
              icon: { padding: 0 },
              wrap: {
                alignItems: 'flex-start',
                height: '60px',
                paddingTop: 9,
              },
            }}
          >
            <div style={{ fontSize: 14, marginTop: 2, lineHeight: '22px' }}>
              {globalUser?.name?.charAt?.(0)?.toUpperCase?.() + globalUser?.name?.slice?.(1)}
            </div>
            <div style={{ fontSize: 12, marginTop: 5 }}> {currentIdentity?.roleName}</div>
          </MenuItem>
        </UserInfoPanelPopover>
        {/*<MenuItem*/}
        {/*  active={menuActive === baseConfig?.[0]?.children[8]?.key}*/}
        {/*  onClick={handleServiceConfigClick}*/}
        {/*  title={'移动端(筑筑侠)'}*/}
        {/*  badgeColor="#0064FF"*/}
        {/*  collapsed={menuCollapsed}*/}
        {/*>*/}
        {/*  移动端(筑筑侠)*/}
        {/*</MenuItem>*/}
        <MenuCollapseBtn collapsed={menuCollapsed} onClick={handleCollapse} />
        <img className={styles.menuSideBg} src={menuSideBg}></img>
      </div>
    </div>
  )
})

export default MenuSide
